import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import {
  getpanelproducts,
  getUserInfo,
  assignProduct,
} from "../../api/ProductAssignment/productAssignment";
import ResponseStatus from "../../util/enums";
import ProcessTypeToggle from "./components/ProcessTypeToggle/ProcessTypeToggle";
import ProductList from "./components/ProductList/ProductList";
import ReasonInput from "./components/ReasonInput/ReasonInput";
import UserSearch from "./components/UserSearch/UserSearch";
import SummaryModal from "./components/SummaryModal/SummaryModal";
// import "./ProductAssignment.css";

const ProductAssignPage = ({ onBack }) => {
  const [loader, setLoader] = useState(false);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [reason, setReason] = useState("");
  const [processType, setProcessType] = useState(null);
  const [user, setUser] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [loginType, setLoginType] = useState(2);
  const [showSummary, setShowSummary] = useState(false);
  const [summaryData, setSummaryData] = useState(null);
  const adminUser = JSON.parse(localStorage.getItem("user"));
  const userAdminToken = sessionStorage.getItem("jwtP");

  const resetForm = () => {
    setUser(null);
    setSearchValue("");
    setLoginType(2);
    setProcessType(null);
    setSelectedProduct(null);
    setReason("");
    setProducts([]); // Optional: refresh from API again below
    getPanelProductsHandler(); // refresh product list after reset
  };

  // 🔹 Fetch all available products
  const getPanelProductsHandler = async () => {
    setLoader(true);
    try {
      const res = await getpanelproducts(userAdminToken);

      if (res.data && res.data.ResponseStatus === ResponseStatus.Success) {
        setLoader(false);
        setProducts(res.data.ResponseData);
      } else {
        setLoader(false);
        toast.error(res.data.ResponseMessage || "Ürünler alınamadı");
      }
    } catch (error) {
      setLoader(false);
      toast.error("Sunucu bağlantı hatası");
    }
  };

  // 🔹 Search user by email/phone
  const getUserInfoHandler = async () => {
    if (!searchValue) {
      toast.error("Lütfen e-posta veya telefon giriniz.");
      return;
    }

    setLoader(true);
    try {
      const payload = {
        UserName: searchValue,
        LoginType: loginType,
      };
      const res = await getUserInfo(payload, userAdminToken, true);
      setLoader(false);

      if (res.data && res.data.ResponseData) {
        setUser(res.data.ResponseData);
        // toast.success("Kullanıcı bulundu.");
      } else if (
        res.data &&
        res.data.ResponseStatus === ResponseStatus.DataIsNull
      ) {
        toast.error("Kullanıcı bulunamadı.");
      } else {
        toast.error(res.data.ResponseMessage || "Bir hata oluştu.");
      }
    } catch (error) {
      setLoader(false);
      toast.error("Sunucu bağlantı hatası, lütfen tekrar deneyin.");
    }
  };

  // 🔹 Assign product to selected user
  const assignProductHandler = async () => {
    if (!user || !selectedProduct || !reason || !processType) {
      toast.error("Lütfen tüm alanları doldurun.");
      return;
    }

    setLoader(true);
    try {
      const payload = {
        UserId: user.UserId,
        StoreProductId: selectedProduct.ProductId,
        HasError: processType == "error",
        Description: `${processType || ""} - ${reason || ""}`,
      };

      const res = await assignProduct(payload, userAdminToken, true);
      setLoader(false);

      if (res.data && res.data.ResponseStatus === ResponseStatus.Success) {
        toast.success("Ürün başarıyla atandı!");
        const summaryPayload = {
          user,
          selectedProduct,
          reason,
          processType,
        };
        setSummaryData(summaryPayload);
        setShowSummary(true);
        // resetForm();
      } else if (
        res.data &&
        res.data.ResponseStatus === ResponseStatus.DataIsNull
      ) {
        toast.error("Atama işlemi başarısız oldu (data is null).");
      } else {
        toast.error(res.data.ResponseMessage || "Bir hata oluştu.");
      }
    } catch (error) {
      setLoader(false);
      toast.error("Sunucu bağlantı hatası, lütfen yetkililere ulaşın.");
    }
  };

  useEffect(() => {
    getPanelProductsHandler();
  }, []);

  const isUserStepComplete = !!user;
  const isProcessStepEnabled = isUserStepComplete;
  const isProductStepEnabled = !!processType && isProcessStepEnabled;
  const isReasonStepEnabled = !!selectedProduct && isProductStepEnabled;

  return (
    <div className="product-assign-page">
      <ToastContainer />
      <div className="header">
        <h2>Ürün Atama</h2>
        <button onClick={onBack}>Geri Dön</button>
      </div>
      <div className="code-page-layout">
        <div>
          {/* <DisabledOverlay enabled={true}> */}
          <div className={`section-wrapper enabled`}>
            <UserSearch
              value={searchValue}
              onChange={setSearchValue}
              loginType={loginType}
              setLoginType={setLoginType}
              onSearch={getUserInfoHandler}
              loader={loader}
              user={user}
            />
          </div>

          <div
            className={`section-wrapper ${
              isProcessStepEnabled ? "enabled" : "disabled"
            }`}
          >
            <ProcessTypeToggle value={processType} onChange={setProcessType} />
            {!isProcessStepEnabled && <div className="overlay" />}
          </div>

          <div
            className={`section-wrapper ${
              isProductStepEnabled ? "enabled" : "disabled"
            }`}
          >
            <ProductList
              list={products}
              selected={selectedProduct}
              onSelect={setSelectedProduct}
            />
            {!isProductStepEnabled && <div className="overlay" />}
          </div>
        </div>
        <div className="reasonAndButtonsBox">
          <div
            className={`section-wrapper ${
              isReasonStepEnabled ? "enabled" : "disabled"
            }`}
          >
            <ReasonInput value={reason} onChange={setReason} />
            <button
              className="primary-btn-assign-product"
              onClick={assignProductHandler}
              disabled={loader || reason.length < 10}
            >
              {loader ? "Atanıyor..." : "Ürünü Ata"}
            </button>
            {!isReasonStepEnabled && <div className="overlay" />}
          </div>
        </div>
        <SummaryModal
          isOpen={showSummary}
          onClose={() => {
            setShowSummary(false);
            resetForm();
          }}
          data={summaryData}
        />
      </div>
    </div>
  );
};

export default ProductAssignPage;
